export default __webpack_public_path__ + "images/1c4f8e1bae398b5b880cf357e9e7859d.svg";